(function(){
  'use strict';
  var mobileToggle=document.querySelector('.mobile-menu-toggle');
  var navList=document.querySelector('.nav-list');
  if(mobileToggle&&navList){
    mobileToggle.addEventListener('click',function(){
      navList.classList.toggle('active');
      this.classList.toggle('active');
    });
  }
  var ageModal=document.querySelector('.age-modal-overlay');
  if(ageModal){
    if(sessionStorage.getItem('age_verified')==='true'){
      ageModal.classList.add('hidden');
    }
    var yesBtn=ageModal.querySelector('.age-modal__btn--yes');
    var noBtn=ageModal.querySelector('.age-modal__btn--no');
    if(yesBtn){yesBtn.addEventListener('click',function(){sessionStorage.setItem('age_verified','true');ageModal.classList.add('hidden');});}
    if(noBtn){noBtn.addEventListener('click',function(){window.location.href='https://www.google.com';});}
  }
  document.querySelectorAll('.qty-selector').forEach(function(sel){
    var input=sel.querySelector('input');
    var minus=sel.querySelector('.qty-minus');
    var plus=sel.querySelector('.qty-plus');
    if(minus)minus.addEventListener('click',function(){var v=parseInt(input.value)||1;if(v>1)input.value=v-1;});
    if(plus)plus.addEventListener('click',function(){var v=parseInt(input.value)||1;input.value=v+1;});
  });
})();
